// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2zYT6","image":"Header_image__157AL","name":"Header_name__8t59g","info":"Header_info__1maf0","infoRow":"Header_infoRow__1FOFo"};